import React, { useEffect, useState } from 'react';

const today = new Date().toISOString().slice(0, 10);

export default function SessionForm({ tripTypes, session, onSave, onCancel }) {
  const firstType = tripTypes.find((item) => item.active) || tripTypes[0];
  const [values, setValues] = useState(() => session || {
    trip_type_id: firstType?.id || '',
    date: today,
    start_time: firstType?.default_start_time || '06:00',
    capacity: firstType?.default_capacity || 6,
    notes: ''
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (session) setValues(session);
  }, [session]);

  const update = (event) => {
    const { name, value } = event.target;
    const next = { ...values, [name]: name === 'capacity' ? Number(value) : value };

    if (name === 'trip_type_id' && !session) {
      const type = tripTypes.find((item) => item.id === value);
      next.start_time = type.default_start_time;
      next.capacity = type.default_capacity;
    }

    setValues(next);
  };

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');

    const result = await onSave(values);

    setSaving(false);

    if (result?.ok === false) {
      setError(result.error);
      return;
    }

    onCancel();
  };

  return (
    <form className="form-stack" onSubmit={submit}>
      {error && <div className="alert error">{error}</div>}
      <label>
        Trip Type
        <select name="trip_type_id" value={values.trip_type_id} onChange={update} required>
          {tripTypes
            .filter((item) => item.active || item.id === values.trip_type_id)
            .map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <div className="form-grid">
        <label>
          Date
          <input type="date" name="date" min={session ? undefined : today} value={values.date} onChange={update} required />
        </label>
        <label>
          Start Time
          <input type="time" name="start_time" value={values.start_time} onChange={update} required />
        </label>
      </div>
      <label>
        Capacity
        <input type="number" name="capacity" min="1" value={values.capacity} onChange={update} required />
      </label>
      <label>
        Notes
        <textarea name="notes" rows="3" value={values.notes || ''} onChange={update} placeholder="Optional guide notes" />
      </label>
      <div className="form-actions">
        <button type="button" className="button secondary" onClick={onCancel}>Cancel</button>
        <button className="button primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save Fishing Date'}
        </button>
      </div>
    </form>
  );
}